var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUniformes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03962 2.87168C9.26083 2.88542 9.62518 1.86858 9.76832 2.03347C10.9524 3.39383 13.3467 3.27017 14.1925 2.06096C14.3877 1.77239 14.6089 2.96786 14.9472 2.87168V8.73909H9.02661V2.87168H9.03962Z",
    fill: "#880E4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9219 19.719C21.9479 20.2549 21.9609 20.7771 21.987 21.2442L22 21.6977H21.5706H19.0722H18.6818L18.6688 21.2717L18.6038 19.7053H21.9479L21.9219 19.719Z",
    fill: "#880E4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39623 19.719L5.33116 21.2855L5.31815 21.7114H4.92778H2.42941H2L2.01301 21.258C2.02602 20.7908 2.05205 20.2686 2.07807 19.7327H5.42225L5.39623 19.719Z",
    fill: "#880E4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7521 2.8039C16.0403 2.83138 18.4476 3.06498 19.0462 4.45282C19.5276 5.57957 19.931 6.55518 20.2693 7.48957C20.6077 8.43769 20.8809 9.31711 21.1021 10.2378C21.3624 11.3233 21.5576 13.3295 21.7007 15.5143C21.7918 16.9296 21.8568 18.4274 21.9219 19.7877H18.5777L18.2134 11.6119L17.4196 9.50949V20.1862C17.4196 20.6809 17.2244 21.1343 16.9121 21.4641C16.5998 21.7939 16.1704 22 15.702 22H8.31097C7.84253 22 7.41312 21.7939 7.10082 21.4641C6.78853 21.1343 6.59334 20.6809 6.59334 20.1862V9.52323L5.79959 11.6256L5.43524 19.8015H2.09106C2.14311 18.4411 2.22119 16.9296 2.31227 15.528C2.45541 13.3432 2.63758 11.337 2.91084 10.2515C3.13205 9.33085 3.40531 8.43769 3.74363 7.50331C4.08196 6.56892 4.48534 5.57957 4.9668 4.46656C5.24006 3.83447 5.85164 3.46347 6.52828 3.22987C7.36107 2.95505 8.37604 2.84512 9.24786 2.79016C9.31293 4.52152 10.5231 5.90936 12.0065 5.90936C13.4769 5.90936 14.687 4.53526 14.7651 2.81764L14.7521 2.8039Z",
    fill: "#C72464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8243 6.51395C10.1587 6.51395 9.13071 4.34288 9.15673 2.79015L9.42999 2.3367C9.66421 1.96569 9.82036 1.85577 9.84638 2.24051C9.93747 3.44972 10.5621 5.27726 11.9934 5.40093L11.8243 6.51395Z",
    fill: "#780B45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1626 6.51395C13.8281 6.51395 14.8561 4.34288 14.8301 2.79015L14.5568 2.3367C14.3226 1.96569 14.1665 1.85577 14.1404 2.24051C14.0493 3.44972 13.4248 5.27726 11.9934 5.40093L12.1626 6.51395Z",
    fill: "#780B45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3449 8.58887H11.3169L11.0957 13.1509L13.2558 15.0059L12.3449 8.58887Z",
    fill: "#880E4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2558 14.9922L13.3729 15.8853L11.0957 18.4961L11.369 13.3707L13.2558 14.9922Z",
    fill: "#F06292"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.447 6.28033H12.462L12.9435 9.13845L11.0957 13.1508L11.447 6.28033Z",
    fill: "#F06292"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5881 5.95058C11.1606 6.22541 11.7592 6.45901 11.7592 6.61016C11.7592 6.77506 11.1606 7.26974 10.5881 7.26974C10.0155 7.26974 10.1977 6.96744 10.1977 6.61016C10.1977 6.23915 10.0155 5.66201 10.5881 5.95058Z",
    fill: "#FF6D00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5029 5.95058C12.9303 6.22541 12.3318 6.45901 12.3318 6.61016C12.3318 6.77506 12.9303 7.26974 13.5029 7.26974C14.0754 7.26974 13.8932 6.96744 13.8932 6.61016C13.8932 6.23915 14.0754 5.66201 13.5029 5.95058Z",
    fill: "#FF6D00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0066 7.20107C12.3228 7.20107 12.5792 6.93653 12.5792 6.61021C12.5792 6.28389 12.3228 6.01935 12.0066 6.01935C11.6904 6.01935 11.4341 6.28389 11.4341 6.61021C11.4341 6.93653 11.6904 7.20107 12.0066 7.20107Z",
    fill: "#E65100"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUniformes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Uniformes.b45aa784.svg";
export { ForwardRef as ReactComponent };